export default "__VITE_ASSET__BoqtOoTs__"